<template>
  <aside class="sidebar">
    <img class="sidebar__fc-logo" alt="FightCamp logo" src="../assets/logo.png">
    <nav class="sidebar__nav">
      <router-link class="sidebar__nav-item" :to="{ name: 'Dashboard' }" exact-active-class="sidebar__nav-item--active">
        <font-awesome-icon class="sidebar__nav-icon" icon="border-all" />
        <span class="sidebar__nav-label">Dashboard</span>
      </router-link>
      <router-link class="sidebar__nav-item" :to="{ name: 'Membership' }" exact-active-class="sidebar__nav-item--active">
        <font-awesome-icon class="sidebar__nav-icon" icon="desktop" />
        <span class="sidebar__nav-label">Membership & Billing</span>
      </router-link>
      <router-link class="sidebar__nav-item" :to="{ name: 'Offers' }" exact-active-class="sidebar__nav-item--active">
        <font-awesome-icon class="sidebar__nav-icon" icon="tag" />
        <span class="sidebar__nav-label">Offers</span>
      </router-link>
      <a class="sidebar__nav-item" href="https://joinfightcamp.com/shop/accessories?utm_source=customer_dashboard&utm_medium=sidebar&utm_campaign=shop" target="_blank" rel="noopener noreferrer">
        <font-awesome-icon class="sidebar__nav-icon" icon="shopping-cart" />
        <span class="sidebar__nav-label">Shop</span>
      </a>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'Sidebar',
};
</script>

<style lang="scss" scoped>
  .sidebar {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $color-blue;
    min-width: 25%;

    @media #{$tablet-up} {
      top: 0;
      left: 0;
      position: fixed;
      min-height: 100%;
      z-index: 1;
      overflow-x: hidden;
      align-items: flex-start;
    }

    &__fc-logo {
      padding: 2rem 0;
      max-width: 100px;

      @media #{$tablet-up} {
        padding: 2rem 1.5rem;
        position: static;
        max-width: 120px;
      }
    }

    &__nav {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-top: 1rem;

      @media #{$tablet-up} {
        display: flex;
        flex-direction: column;
      }
    }

    &__nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 0.4rem;
      padding: 0.9rem 0.5rem;
      color: rgba($color-white, 0.45);
      text-decoration: none;
      border-left: none;
      border-bottom: 2px solid transparent;
      transition: color 0.15s ease, border-color 0.15s ease;
      font-size: 0.7rem;
      letter-spacing: 0.04em;
      text-align: center;
      text-transform: uppercase;

      @media #{$tablet-up} {
        flex-direction: row;
        justify-content: flex-start;
        gap: 1rem;
        padding: 0.9rem 1.5rem;
        border-left: 3px solid transparent;
        border-bottom: none;
        font-size: 0.95rem;
        letter-spacing: 0.01em;
        text-align: left;
        text-transform: none;
      }

      &:hover {
        color: rgba($color-white, 0.8);
      }

      &--active {
        color: $color-white;
        border-bottom-color: $color-red;

        @media #{$tablet-up} {
          border-bottom-color: transparent;
          border-left-color: $color-red;
        }
      }
    }

    &__nav-icon {
      width: 18px;
      text-align: center;
      flex-shrink: 0;
      font-size: 1.1rem;

      @media #{$tablet-up} {
        font-size: 1rem;
      }
    }
  }
</style>
